import React from "react";
import DepChipTypeahead, {
  type DepCandidate,
} from "../../../DepChipTypeahead/DepChipTypeahead";

/** "+ add" → the standard predecessor typeahead, scoped to this editor cell. */
const AddTieButton: React.FC<{
  candidates: DepCandidate[];
  exclude: Set<string>;
  onPick: (id: string) => void;
}> = ({ candidates, exclude, onPick }) => {
  const [open, setOpen] = React.useState(false);
  const btnRef = React.useRef<HTMLButtonElement>(null);
  const list = React.useMemo(
    () => candidates.filter((c) => !exclude.has(c.instanceId)),
    [candidates, exclude],
  );
  return (
    <div className="dep-table-add-wrap">
      <button
        ref={btnRef}
        type="button"
        className="dep-table-add-btn"
        onClick={() => setOpen((o) => !o)}
      >
        + add
      </button>
      {open && (
        <DepChipTypeahead
          candidates={list}
          anchorRef={btnRef}
          onPick={(c) => {
            onPick(c.instanceId);
            setOpen(false);
          }}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default AddTieButton;
